{
    "v": "5.10.2",
    "fr": 25,
    "ip": 0,
    "op": 61,
    "w": 500,
    "h": 500,
    "nm": "15-Helmet",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0.157, 0.176, 0.212, 1], "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 75.8333333333333,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Lines 4",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": -144.242, "ix": 10 },
                "p": { "a": 0, "k": [359.253, 186.001, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [-0.48, 160.877, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-24.958, 156.248],
                                        [-41.132, 172.422]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-0.445, 160.877],
                                        [-0.445, 183.75]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [23.998, 159.772],
                                        [40.172, 175.946]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.46], "y": [1] },
                                "o": { "x": [0.26], "y": [0] },
                                "t": 27.94,
                                "s": [0]
                            },
                            { "t": 35.0830078125, "s": [100] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.46], "y": [1] },
                                "o": { "x": [0.26], "y": [0] },
                                "t": 24.667,
                                "s": [0]
                            },
                            { "t": 30.9169921875, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 2,
                    "ix": 4,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 24,
            "op": 35,
            "st": 23,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Lines 3",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": -216.143, "ix": 10 },
                "p": { "a": 0, "k": [137.253, 183.001, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [-0.48, 160.877, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-24.958, 156.248],
                                        [-41.132, 172.422]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-0.445, 160.877],
                                        [-0.445, 183.75]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [23.998, 159.772],
                                        [40.172, 175.946]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.46], "y": [1] },
                                "o": { "x": [0.26], "y": [0] },
                                "t": 26.94,
                                "s": [0]
                            },
                            { "t": 34.0830078125, "s": [100] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.46], "y": [1] },
                                "o": { "x": [0.26], "y": [0] },
                                "t": 23.667,
                                "s": [0]
                            },
                            { "t": 29.9169921875, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 2,
                    "ix": 4,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 23,
            "op": 34,
            "st": 22,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Helmet",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.76], "y": [1] },
                            "o": { "x": [0.24], "y": [0] },
                            "t": 23,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.76], "y": [1] },
                            "o": { "x": [0.279], "y": [0] },
                            "t": 27,
                            "s": [-4.822]
                        },
                        {
                            "i": { "x": [0.768], "y": [1] },
                            "o": { "x": [0.24], "y": [0] },
                            "t": 31,
                            "s": [8.769]
                        },
                        {
                            "i": { "x": [0.76], "y": [1] },
                            "o": { "x": [0.24], "y": [0] },
                            "t": 35,
                            "s": [-8.189]
                        },
                        { "t": 39, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.5, "y": 1 },
                            "o": { "x": 0.5, "y": 0 },
                            "t": 0,
                            "s": [249.669, 126.023, 0],
                            "to": [0, -4.167, 0],
                            "ti": [0, -9.167, 0]
                        },
                        {
                            "i": { "x": 0.5, "y": 1 },
                            "o": { "x": 0.5, "y": 0 },
                            "t": 14,
                            "s": [249.669, 101.023, 0],
                            "to": [0, 9.167, 0],
                            "ti": [0, -4.167, 0]
                        },
                        {
                            "i": { "x": 0.5, "y": 1 },
                            "o": { "x": 0.5, "y": 0 },
                            "t": 26,
                            "s": [249.669, 181.023, 0],
                            "to": [0, 4.167, 0],
                            "ti": [0, 9.167, 0]
                        },
                        { "t": 50, "s": [249.669, 126.023, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [249.669, 126.023, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-11.109, -50.655],
                                                            [11.109, 50.655]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-11.109, -50.655],
                                                            [8.109, 37.655]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-11.385, -42.155],
                                                            [10.982, 68.155]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [-11.109, -50.655],
                                                            [11.109, 50.655]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [165.206, 199.166], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [11.477, -50.573],
                                                            [-11.477, 50.573]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [11.477, -50.573],
                                                            [-6.977, 27.573]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [11.201, -42.073],
                                                            [-11.603, 68.073]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [11.477, -50.573],
                                                            [-11.477, 50.573]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [335.162, 199.784], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [13.05, 0.047],
                                                            [0, 0],
                                                            [-1.554, -12.957],
                                                            [0, 0],
                                                            [-10.963, -0.04],
                                                            [0, 0],
                                                            [-1.385, 10.875],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [-13.05, -0.047],
                                                            [0, 0],
                                                            [1.306, 10.885],
                                                            [0, 0],
                                                            [10.963, 0.04],
                                                            [0, 0],
                                                            [1.648, -12.946]
                                                        ],
                                                        "v": [
                                                            [25.72, -75.043],
                                                            [-25.562, -75.229],
                                                            [-47.202, -50.928],
                                                            [-34.375, 56.01],
                                                            [-12.893, 75.139],
                                                            [11.958, 75.229],
                                                            [33.578, 56.257],
                                                            [47.183, -50.585]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [13.05, 0.047],
                                                            [0, 0],
                                                            [-1.554, -12.957],
                                                            [0, 0],
                                                            [-10.963, -0.04],
                                                            [0, 0],
                                                            [-1.385, 10.875],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [-13.05, -0.047],
                                                            [0, 0],
                                                            [1.306, 10.885],
                                                            [0, 0],
                                                            [10.963, 0.04],
                                                            [0, 0],
                                                            [1.648, -12.946]
                                                        ],
                                                        "v": [
                                                            [25.72, -75.043],
                                                            [-25.562, -75.229],
                                                            [-47.202, -50.928],
                                                            [-32.875, 25.01],
                                                            [-11.393, 44.139],
                                                            [13.458, 44.229],
                                                            [35.078, 25.257],
                                                            [47.183, -50.585]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [13.05, 0.047],
                                                            [0, 0],
                                                            [-1.554, -12.957],
                                                            [0, 0],
                                                            [-10.963, -0.04],
                                                            [0, 0],
                                                            [-1.385, 10.875],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [-13.05, -0.047],
                                                            [0, 0],
                                                            [1.306, 10.885],
                                                            [0, 0],
                                                            [10.963, 0.04],
                                                            [0, 0],
                                                            [1.648, -12.946]
                                                        ],
                                                        "v": [
                                                            [25.444, -66.543],
                                                            [-25.838, -66.729],
                                                            [-47.478, -42.428],
                                                            [-34.501, 73.51],
                                                            [-13.019, 92.639],
                                                            [11.831, 92.729],
                                                            [33.452, 73.757],
                                                            [46.907, -42.085]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [13.05, 0.047],
                                                            [0, 0],
                                                            [-1.554, -12.957],
                                                            [0, 0],
                                                            [-10.963, -0.04],
                                                            [0, 0],
                                                            [-1.385, 10.875],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [-13.05, -0.047],
                                                            [0, 0],
                                                            [1.306, 10.885],
                                                            [0, 0],
                                                            [10.963, 0.04],
                                                            [0, 0],
                                                            [1.648, -12.946]
                                                        ],
                                                        "v": [
                                                            [25.72, -75.043],
                                                            [-25.562, -75.229],
                                                            [-47.202, -50.928],
                                                            [-34.375, 56.01],
                                                            [-12.893, 75.139],
                                                            [11.958, 75.229],
                                                            [33.578, 56.257],
                                                            [47.183, -50.585]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0.157, 0.176, 0.212, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [250.402, 192.837], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [250.402, 192.837], "ix": 2 },
                            "a": { "a": 0, "k": [250.402, 192.837], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [-103.278, 30.349],
                                                            [0, 0],
                                                            [-0.03, 8.244],
                                                            [0, 0],
                                                            [10.293, 0.037],
                                                            [107.236, -0.779],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-7.89, -2.383],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [7.91, -2.324],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-107.236, 0.779],
                                                            [-10.293, -0.037],
                                                            [0, 0],
                                                            [-0.03, 8.243],
                                                            [0, 0],
                                                            [103.046, 31.128]
                                                        ],
                                                        "v": [
                                                            [157.959, 7.608],
                                                            [158.116, 7.562],
                                                            [171.499, -10.252],
                                                            [171.499, -10.252],
                                                            [152.929, -28.957],
                                                            [0.068, -29.513],
                                                            [-152.793, -30.069],
                                                            [-171.499, -11.499],
                                                            [-171.499, -11.495],
                                                            [-158.251, 6.414],
                                                            [-158.25, 6.415]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [-78.055, -4.842],
                                                            [0, 0],
                                                            [-0.03, 8.244],
                                                            [0, 0],
                                                            [10.293, 0.037],
                                                            [107.236, -0.779],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-7.89, -2.383],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [7.91, -2.324],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-107.236, 0.779],
                                                            [-10.293, -0.037],
                                                            [0, 0],
                                                            [-0.03, 8.243],
                                                            [0, 0],
                                                            [96.154, 0.352]
                                                        ],
                                                        "v": [
                                                            [158.065, -15.392],
                                                            [158.223, -15.438],
                                                            [171.606, -33.252],
                                                            [171.606, -33.252],
                                                            [153.036, -51.957],
                                                            [0.171, -71.013],
                                                            [-152.686, -53.069],
                                                            [-171.392, -34.499],
                                                            [-171.392, -34.495],
                                                            [-158.144, -16.586],
                                                            [-158.144, -16.585]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [-101.126, 40.66],
                                                            [0, 0],
                                                            [-0.03, 12.268],
                                                            [0, 0],
                                                            [10.293, 0.056],
                                                            [107.236, -1.16],
                                                            [0, 0],
                                                            [0.037, -15.317],
                                                            [0, 0],
                                                            [-7.89, -3.547],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [7.91, -3.459],
                                                            [0, 0],
                                                            [0.037, -15.317],
                                                            [0, 0],
                                                            [-107.236, 1.16],
                                                            [-10.293, -0.056],
                                                            [0, 0],
                                                            [-0.03, 12.265],
                                                            [0, 0],
                                                            [103.583, 39.937]
                                                        ],
                                                        "v": [
                                                            [157.959, 26.106],
                                                            [158.116, 26.037],
                                                            [171.499, -0.471],
                                                            [171.499, -0.471],
                                                            [152.929, -28.306],
                                                            [0.136, -4.133],
                                                            [-152.793, -29.96],
                                                            [-171.499, -2.327],
                                                            [-171.499, -2.321],
                                                            [-158.251, 24.329],
                                                            [-158.25, 24.329]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [-103.278, 30.349],
                                                            [0, 0],
                                                            [-0.03, 8.244],
                                                            [0, 0],
                                                            [10.293, 0.037],
                                                            [107.236, -0.779],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-7.89, -2.384],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [7.91, -2.324],
                                                            [0, 0],
                                                            [0.037, -10.293],
                                                            [0, 0],
                                                            [-107.236, 0.779],
                                                            [-10.293, -0.037],
                                                            [0, 0],
                                                            [-0.03, 8.243],
                                                            [0, 0],
                                                            [103.046, 31.128]
                                                        ],
                                                        "v": [
                                                            [157.959, 7.608],
                                                            [158.116, 7.562],
                                                            [171.499, -10.252],
                                                            [171.499, -10.252],
                                                            [152.929, -28.957],
                                                            [0.068, -29.513],
                                                            [-152.793, -30.069],
                                                            [-171.499, -11.499],
                                                            [-171.499, -11.495],
                                                            [-158.251, 6.414],
                                                            [-158.25, 6.415]
                                                        ],
                                                        "c": true
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0, 0, 0, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 2,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [249.668, 352.234], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [-60.399, 19.644],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [52.275, -92.088],
                                                            [-52.126, 51.17],
                                                            [-52.275, 92.088]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [-61.087, 21.004],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [52.275, -92.088],
                                                            [-51.948, 42.67],
                                                            [-52.168, 69.088]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [-60.399, 19.644],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [51.999, -83.588],
                                                            [-52.253, 68.671],
                                                            [-52.275, 92.088]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "o": [
                                                            [-60.399, 19.644],
                                                            [0, 0],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [52.275, -92.088],
                                                            [-52.126, 51.171],
                                                            [-52.275, 92.088]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0, 0, 0, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 1,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [150.812, 230.083], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 1,
                                        "k": [
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 3,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [60.254, 20.082]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [51.529, 92.465],
                                                            [51.678, 51.548],
                                                            [-51.679, -92.465]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 17,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [61.774, 22.66]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [51.636, 69.465],
                                                            [51.856, 43.048],
                                                            [-51.679, -92.465]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "i": { "x": 0.5, "y": 1 },
                                                "o": { "x": 0.5, "y": 0 },
                                                "t": 29,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [60.254, 20.082]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [51.529, 92.465],
                                                            [51.552, 69.048],
                                                            [-51.955, -83.965]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            },
                                            {
                                                "t": 53,
                                                "s": [
                                                    {
                                                        "i": [
                                                            [0, 0],
                                                            [0, 0],
                                                            [60.254, 20.082]
                                                        ],
                                                        "o": [
                                                            [0, 0],
                                                            [0.244, -66.977],
                                                            [0, 0]
                                                        ],
                                                        "v": [
                                                            [51.529, 92.465],
                                                            [51.678, 51.548],
                                                            [-51.679, -92.465]
                                                        ],
                                                        "c": false
                                                    }
                                                ]
                                            }
                                        ],
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": {
                                        "a": 0,
                                        "k": [0, 0, 0, 1],
                                        "ix": 3,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                                    },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": {
                                        "a": 0,
                                        "k": 24,
                                        "ix": 5,
                                        "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                                    },
                                    "lc": 1,
                                    "lj": 2,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [349.405, 230.805], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 3",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 3,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [349.405, 230.805], "ix": 2 },
                            "a": { "a": 0, "k": [349.405, 230.805], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 75,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 75.8333333333333,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
